import { toast } from "sonner";
import { DropResult } from "@hello-pangea/dnd";
import { RouteModel } from "../../domain/models/routeModel";

export default function MoveSlipToRoute(
  routes: RouteModel[],
  dropResult: DropResult,
): RouteModel[] {
  if (!dropResult.destination) {
    return routes;
  }

  // Get the draggable element.
  const draggable = dropResult.draggableId;
  const slipId = draggable.replace("slip:", "");

  const packingSlip = routes
    .flatMap((r) => r.packingSlips)
    .find((slip) => slip.id === slipId);

  if (!packingSlip) {
    toast.error("Could not find packing slip:" + slipId + " to move");
    return routes;
  }

  // Get the destination element and move the draggable from old to new place.
  const destination = dropResult.destination.droppableId;
  const routeId = destination.replace("route:", "");

  return routes.map((route) => {
    //Remove slip from old route.
    if (route.packingSlips.some((slip) => slip.id === packingSlip.id)) {
      route.packingSlips = route.packingSlips.filter(
        (slip) => slip.id !== packingSlip.id,
      );
    }

    //Add slip to new route.
    if (route.id === routeId) {
      const existingSlip = route.packingSlips.find(
        (slip) => slip.relation.id === packingSlip.relation.id,
      );
      if (existingSlip) {
        existingSlip.requests.push(...packingSlip.requests);
        existingSlip.pickup_amount =
          (packingSlip.pickup_amount ?? 0) + (existingSlip.pickup_amount ?? 0);
      } else {
        route.packingSlips.splice(
          dropResult.destination?.index ?? 0,
          0,
          packingSlip,
        );
      }
    }

    return route;
  });
}
